module.exports = __webpack_public_path__ + "media/packs/images/flags/LR-15dfcffd734f9a354534aa80fea580d2.png";